import React from 'react';
import { LinearProgress, styled, Box } from '@mui/material';
import './style.css'

type LinearProgressDisplayProps = {
  progress: number;
};

const BorderLinearProgress = styled(LinearProgress)(({  }) => ({
  height: 10,
  borderRadius: 5,
}));

const LinearProgressDisplay: React.FC<LinearProgressDisplayProps> = ({ progress }) => (
  <Box sx={{ width: '100%', padding: 2 }}>
    <BorderLinearProgress variant="determinate" value={progress} />
  </Box>
);

export default LinearProgressDisplay;